import type { WellOrdering } from './types';

/**
 * The orderings the UI offers. Every option names an axis, not a direction: reversal
 * is what Flip does, and offering it here too would let two controls disagree about
 * which end is A. The backend accepts the reversed compass sorts; the UI does not.
 */
export const WELL_ORDERINGS: Array<{ id: WellOrdering; label: string }> = [
  { id: 'as_selected', label: 'As picked' },
  { id: 'west_east', label: 'East/West' },
  { id: 'north_south', label: 'North/South' },
  { id: 'trend', label: 'Along well trend' },
  { id: 'shortest_path', label: 'Shortest path' },
];
